import type { BackendUserRole } from "./platform-api";

/**
 * The roles an admin can give someone, for pickers that can't read the
 * platform roles list. Supervisor is retired (BR-208): a superior sees their
 * direct reports in My team instead (FEAT-2026-026).
 */
export const TENANT_ROLES: { key: BackendUserRole; label: string }[] = [
  { key: "TENANT_OWNER", label: "Tenant Owner" },
  { key: "HR_MANAGER", label: "HR Manager" },
  { key: "OPERATIONS_ADMIN", label: "Operations Admin" },
  { key: "SITE_ADMIN", label: "Site Admin" },
  { key: "EMPLOYEE", label: "Employee" },
];

/** Drop retired roles from a picker — unless it's the role the user already has. */
export function assignableRoles<T extends { key: string }>(roles: T[], current?: string): T[] {
  return roles.filter((r) => r.key !== "SUPERVISOR" || r.key === current);
}
